module.exports = require("../utils/EventEmitter");


//////////////////
// WEBPACK FOOTER
// external "../utils/EventEmitter"
// module id = 6
// module chunks = 5